module.exports = __webpack_public_path__ + "img/icon_list_download_selected2.8adf721b.svg";